<template>
  <div class="menu-button">
    <MenuButton buttonLabel="Settings" class="menu-button">
      <MenuButtonItem @click="deleteProperty" title="Delete property" icon="trash" variant="dangerous" />
    </MenuButton>

    <PropertyDeleteModal ref="deleteModalRef" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { MenuButton, MenuButtonItem } from '@tallo/design-system';

import PropertyDeleteModal from './property-delete-modal.vue';

const deleteModalRef = ref<InstanceType<typeof PropertyDeleteModal>>();

function deleteProperty() {
  deleteModalRef.value?.modalRef?.show();
}
</script>
